import bookmark from '../assets/Images/bookmark-desktop-preview.jpg';
import loop from '../assets/Images/loopstudios-desktop-preview.jpg';
import crowd from '../assets/Images/crowd-fund-desktop-preview.jpg';
import bank from '../assets/Images/easybank-desktop-preview.jpg';
import manage from '../assets/Images/manage-desktop-preview.jpg';
import insure from '../assets/Images/desktop-preview.jpg';
export const projectsData = [
  {
    id: 1,
    img: loop,
    text: 'Loopstudios landing page',
    link: 'https://loopstudios-landing-page-main-silk.vercel.app/',
  },

  {
    id: 2,
    img: crowd,
    text: 'Crowdfunding page',
    link: 'https://crowdfunding-product-page-main-lilac.vercel.app/',
  },
  {
    id: 3,
    img: bank,
    text: 'Easybank landing page',
    link: 'https://4-easybank-landing-page-master.vercel.app/',
  },
  {
    id: 4,
    img: manage,
    text: 'Manage landing page',
    link: 'https://3-manage-landing-page-master.vercel.app/',
  },
  {
    id: 5,
    img: bookmark,
    text: 'Bookmark landing page',
    link: 'https://bookmark-landing-page-master-three.vercel.app/',
  },
  {
    id: 6,
    img: insure,
    text: 'Insure landing page',
    link: 'https://insure-landing-page-master-ebon.vercel.app/',
  },
];
